import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type {
    SalesTaxReportResponse,
    SummaryNetCollectedBreakdownByPaymentTypeReportItem,
    SummaryReportRequestData,
    TipsAndGratuityByAssignmentReportItem,
} from "../../../../graphql/types"
import { GQLData } from "../../../../graphql/utils"

export const fetchNetCollectedBreakdownByPaymentTypeReportData = (
    headers: Record<string, any>,
    data: SummaryReportRequestData
): Promise<Maybe<SummaryNetCollectedBreakdownByPaymentTypeReportItem>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query summaryNetCollectedBreakdownByPaymentTypeReport($data: SummaryReportRequestData!) {
                  summaryNetCollectedBreakdownByPaymentTypeReport(data: $data) {
                     ...ReportItem
                     children {
                        ...ReportItem
                     }
                  }
                }
                
                fragment ReportItem on SummaryNetCollectedBreakdownByPaymentTypeReportItem {
                    paymentType
                    grossRevenue
                    refundsTotal
                    cardSurcharge
                    cashDiscount
                    serviceFee
                    voidsTotal
                    netRevenue
                    tipsTotal
                    historicalRefunds
                    futureRefunds
                    netCollected
                    losses
                    forfeits
                    gratuityTotal
                    tipsAndGratuityTotal  
                    specialPricings {
                        id
                        name
                        total
                    }        
                    taxes {
                        rowNumber
                        name
                        percentage
                        total
                    }   
                    tips {
                        id
                        name
                        amountTip
                    }      
                }
            `,
            operationName: "summaryNetCollectedBreakdownByPaymentTypeReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.summaryNetCollectedBreakdownByPaymentTypeReport) {
            return response.data
                .summaryNetCollectedBreakdownByPaymentTypeReport as SummaryNetCollectedBreakdownByPaymentTypeReportItem
        }

        return null
    })

export const fetchTipsAndGratuityReportData = (
    headers: Record<string, any>,
    data: SummaryReportRequestData
): Promise<Maybe<TipsAndGratuityByAssignmentReportItem[]>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query tipsAndGratuityReport($data: SummaryReportRequestData!) {
                  tipsAndGratuityReport(data: $data) {
                     ...ReportItem
                     children {
                        ...ReportItem
                        children {
                            ...ReportItem
                        }
                     }
                  }
                }
                
                fragment ReportItem on TipsAndGratuityByAssignmentReportItem {
                    name
                    total
                    columns {
                        name
                        total
                    }
                }
            `,
            operationName: "tipsAndGratuityReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.tipsAndGratuityReport) {
            return response.data.tipsAndGratuityReport
        }
        return null
    })

export type SalesTaxReportData = GQLData<"salesTaxReport", SalesTaxReportResponse>
export const salesTaxReportQuery = `
    query salesTaxReport($data: SummaryReportRequestData!) {
      salesTaxReport(data: $data) {
            collectedTotal
            grandTotal
            cashTotal
            cardTotal
            otherTotal
            rows {
                name
                rate
                collected
                total
                cash
                card
                other
            }
      }
    }               
`
